const sizes = {
	mini: "0.0625rem", // 1px
	tiny: "0.125rem", // 2px
	extraTiny: "0.25rem", // 4px
	small: "0.375rem", // 6px
	compact: "0.5rem", // 8px
	regular: "0.625rem", // 10px
	comfortable: "0.75rem", // 12px
	moderate: "0.875rem", // 14px
	large: "1rem", // 16px
	xLarge: "1.125rem", // 18px
	xxLarge: "1.25rem", // 20px
	huge: "1.375rem", // 22px
	massive: "1.5rem", // 24px
	extraMassive: "1.625rem", // 26px
	xxMassive: "1.75rem", // 28px
	xxxMassive: "1.875rem", // 30px
	jumbo: "2rem", // 32px
	xxJumbo: "2.125rem", // 34px
	xxxJumbo: "2.25rem", // 36px
	giant: "2.375rem", // 38px
	mega: "2.5rem", // 40px
};

const percentages = {
	full: "100%",
	ninety: "90%",
	eighty: "80%",
	seventy: "70%",
	sixty: "60%",
	fifty: "50%",
	forty: "40%",
	thirty: "30%",
	twenty: "20%",
	ten: "10%",
};

const theme = {
	colors: {
		purple: "#745BE7",
		purple2: "#735AE5",
		purpleHover: "#927BFC",
		lightPurple: "#EBE8FF",
		rescheduleBg: "#F3F1FE",
		rescheduleBorder: "#AA9BED",
		rescheduleAccent: "#6F57E9",
		darkPurple: "#743ee1",
		mixedPurple: "#6a6a94",
		whitePurple: "#9B9BB8",
		boxBackgroundGrey: "#EDE8E8",
		lightGreyBg2: "#fafafa",
		borderGrey2: "#f0f0f1",
		black: "#191919",
		charcoal: "#222222",
		silver: "#e0e0e0",
		silverGrey: "#73767D",
		lightGrey: "#ededed",
		lightGrey2: "#F4F4F4",
		darkGrey: "#666666",
		lightGrey3: "#E7E7E7",
		grey45: "#454545",
		darkestGrey: "#4b4b4b",
		white: "#fff",
		whiteSmoke: "#f4f5f6",
		ghostWhite: "#f8f8fe",
		purplishWhite: "#dfe0ff",
		lightPurplishWhite: "#f8f8fe",
		bgPurple: "#F3F1FE",
		pureWhite: "#FFFFFF",
		red: "#FF2222",
		dangerBg: "#FFACAC33",
		darkRed: "#FFC7C7",
		lightRed: "#fee7e7",
		seaGreen: "#EBF9EB",
		lightSeaGreen: "#EBF9EB",
		lightGreenBg: "#F0FDF4",
		lightRedBg: "#FFF1F1",
		lightGreen: "#0cbb32",
		mediumGreen: "#008E27",
		mediumGreen2: "#008236",
		lightGreen2: "#DBF1DD",
		lightGreen3: "#E6FFEF",
		green: "#0d8515",
		neonGreen: "#48C13B",
		honeyBrown: "#968130",
		darkHoneyBrown: "#AC6A00",
		softYellow: "#ffeba0",
		goldenMist: "#febd1e1a",
		lightGoldenMist: "#FFF1DD",
		lightGoldenMist2: "#FFFBEB",
		orange: "#ce5c33",
		disabled: "#E1E1E1",
		grey999: "#999999",
		crimsonRed: "#e71919",
		mediumGrey: "#9ea0a4",
		mistGrey: "#eaebec",
		darkMistGrey: "#d3d3d3",
		softGrey: "#b9b9b9",
		informationalBg: "#F4F9FD",
		informationalBorder: "#d1d9e0",
		lightBlue: "#F3F7FE",
		mediumBlue: "#A9B0BC",
		lightGreyBorder: "#D8D8D8",
		lightGreyBorder2: "#eaeaea",
		lightBlue2: "#3887FF",
		backdrop: "rgba(25, 23, 23, 0.9)",
		lightGreyBg: "#F8F8F8",
		greyText: "#4C4C4C",
		greyBorder: "#dcd9d9",
		lightPurple2: "#EDEBFF",
		grandTotalBg: "#f5f3ff",
		grandTotalBorder: "#c4b5fd",
		lightGreenBorder: "#b9f8cf",
		lightGreenBorder2: "#e2f7e8",
		lightRedBorder: "#fee7e7",
		lightRedBorder2: "#F4CCCC",
		mediumYellow: "#dfbf53",
		lightGreyText: "#bcbcbc",
		darkCyan: "#007595",
		lightCyanBorder: "#a2f4fd80",
		dialogContentBg: "#F7F5F5",
		warningBg: "#fff9db",
		warningIconBg: "#fef3c6",
		warningIcon: "#e17100",
		currentPickupChipBorder: "#106a9a80",
		currentPickupChipText: "#106a9a",
		disabledDateBg: "#EAEAEABA",
		successBannerBg: "#EFFEF5",
		successBannerBorder: "#008E2726",
		pureBlack: "#000000",
		lightBlueBg: "#F4F8FF",
		lightBlueBg2: "#EBF9FC",
		skyBlue: "#2196F3",
		tourOverlay: "rgba(0, 0, 0, 0.65)",
		tourSpotlightBorder: "rgba(116, 91, 231, 0.6)",
		ghostHover: "rgba(0, 0, 0, 0.04)",
		lightHover: "rgba(0, 0, 0, 0.06)",
	},
	gradients: {
		lightPurple: "linear-gradient(91.94deg, #d4f7ff -7.82%, #ffffff 97.15%)",
		labelPanel: "linear-gradient(90deg, #F3F1FE 0%, #FFFFFF 46.45%)",
	},
	fontSize: sizes,
	spacing: sizes,
	fontFamily: {
		primary:
			'"SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
		monospace: 'Menlo, Monaco, Consolas, "Courier New", monospace',
	},
	fontWeight: {
		normal: "400",
		semiBold: "500",
		bold: "600",
		xBold: "700",
	},
	borderRadius: { ...sizes, circle: "50%" },
	height: sizes,
	borderWidth: sizes,
	lineHeight: percentages,
	width: percentages,
	transitions: {
		fast: "0.2s ease",
		normal: "0.3s ease",
		slow: "0.5s ease",
	},
	textLineHeight: {
		tight: "1.3",
		normal: "1.4",
		relaxed: "1.65",
	},
	shadows: {
		small: "0 2px 4px rgba(0, 0, 0, 0.05)",
		medium: "0 4px 6px rgba(0, 0, 0, 0.1)",
		large: "0px -4px 10px 0px #0000001a",
		card: "0 2px 8px rgba(0, 0, 0, 0.05)",
		cardHover: "0 4px 12px rgba(0, 0, 0, 0.1)",
		warehouse: "0 2px 4px rgba(0, 0, 0, 0.05)",
		warehouseHover: "0 4px 8px rgba(0, 0, 0, 0.1)",
		addresses: "0 4px 10px 0 #0000001a",
		tourTooltip:
			"0 8px 32px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.10)",
	},
};

export default theme;
